<!-- 房地产交易代办服务全流程 -->
<template>
	<div class="main">
		<div class="banner">
			<img src="../assets/images/bg.png" alt="" />
		</div>
		<div class="main-container">
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
export default {
	// eslint-disable-next-line vue/multi-word-component-names
	name: 'Main',
	data() {
		return {};
	},
	mounted() {},
	methods: {},
};
</script>

<style scoped>
@import url('@/assets/css/main.css');
.main {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	position: relative;
}
.banner {
	width: 100%;
	height: 100%;
	position: relative;
}
.banner img {
	min-width: var(--main--width);
	height: 70%;
}
.main .main-container {
	padding: 10px 20px 50px;
	width: 1200px;
	min-height: 580px;
	position: absolute;
	bottom: 30px;
	left: 50%;
	z-index: 1;
	-webkit-transform: translate(-50%, -35px);
	transform: translate(-50%, -35px);
	background-color: #fff;
	-webkit-box-shadow: 0 30px 20px -20px rgba(0, 0, 0, 0.15);
	box-shadow: 0 30px 20px -20px rgba(0, 0, 0, 0.15);
	border-radius: 8px;
}
</style>
